import styled from "styled-components";

export const SystemWrap = styled.div`
    & .ant-table-cell{
        vertical-align: middle;
    }
`
